<template>
  <v-content>
    <div id="core-view">
      <div
        v-if="isFreeUserAndLogged"
        v-show="!noticeHidden"
        id="core-aviso-gratuito"
        :class="{ 'core-aviso-gratuito--hidden': noticeHidden }"
      >
        <div class="aviso-content">
          <h4>{{ strings[idioma].msg_aviso_uso_gratuito }}</h4>
          <v-btn
            v-show="showCloseButton" 
            icon 
            small 
            class="close-btn"
            @click="hideNotice"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <Modal :message="''"/>
      <Alert :message="''"/>
      
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
import strings from '../../lang/Strings';
import { getAcessoModulo } from '../../store/auth/actions';
import { AVISO_GRATUITO } from '../../utils/types';
import Alert from '../../views/components/Alert.vue'
import Modal from '../../views/components/Modal.vue'
import { mapState } from 'vuex'

export default {
  components: {
    Alert,
    Modal
  },
  data() {
    return {
      noticeHidden: false,
      showCloseButton: false
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'strings', 'user']),
    isFreeUserAndLogged() {
      return this.user && this.getAcessoModulo({ user: this.user, modulo: AVISO_GRATUITO })
    }
  },
  watch: {
    '$route' (val) {
      document.title = (!_.isNil(val.name) ? (_.isArray(val.name) ? val.name[this.idioma] : val.name) + ' | ' : '') + (process.env.VUE_APP_APP_NAME || 'BR-Corte 5.0');
    }
  },
  mounted() {
    // Mostrar botão de fechar após 30 segundos
    if (this.isFreeUserAndLogged) {
      this.showCloseButtonBeforeTime(30)
      // a cada 1 minutos volta com o aviso
      this.showNoticeIntermitente(1 * 60, 30)
    }
    
  },
  methods: {
    showCloseButtonBeforeTime(time = 30) {
      setTimeout(() => {
        this.showCloseButton = true
      }, time * 1000);
    },
    showNoticeIntermitente(time = 3 * 60, timeClose = 30) {
      setInterval(() => {
        if (!this.noticeHidden) return;
        this.showCloseButton = false;
        this.noticeHidden = false;
        this.showCloseButtonBeforeTime(timeClose)
      }, time * 1000);
    },
    toggleNotice() {
      this.noticeHidden = !this.noticeHidden
    },
    hideNotice() {
      this.noticeHidden = true
    },
    getAcessoModulo({ user, modulo }) {
      let res = getAcessoModulo(this.$store, { user, modulo });
      return res;
    },
  },
  metaInfo () {
    return {
      title: (process.env.VUE_APP_APP_NAME ? process.env.VUE_APP_APP_NAME : 'BR-Corte 5.0'),
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 20px;
  overflow: auto;
  position: relative;
  min-height: 100vh;
}

#core-aviso-gratuito {
  position: fixed;
  top: 0;
  left: 50%; /* Centraliza horizontalmente */
  transform: translateX(-50%); /* Compensa a largura do elemento */
  width: auto; /* Largura automática baseada no conteúdo */
  min-width: 500px; /* Largura mínima */
  background: linear-gradient(135deg, #003366  0%, #001d39  100%);
  color: #fff;
  z-index: 1000;
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.core-aviso-gratuito--hidden {
  transform: translateX(-50%) translateY(-100%); /* Mantém centralizado ao esconder */
  opacity: 0.7;
}

.aviso-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  position: relative;
  gap: 12px;
  min-height: 50px;
}

.aviso-content h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  flex: 1;
  white-space: nowrap;
}

.toggle-icon {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.core-aviso-gratuito--hidden .toggle-icon {
  transform: rotate(180deg);
}

.close-btn {
  color: white !important;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

/* Mostrar ao passar mouse quando escondido */
.core-aviso-gratuito--hidden:hover {
  transform: translateX(-50%) translateY(0); /* Mantém centralizado ao mostrar */
  opacity: 1;
}

@media (max-width: 768px) {
  #core-aviso-gratuito {
    min-width: 300px; /* Largura mínima menor para mobile */
    left: 50%;
    transform: translateX(-50%);
  }
  
  .core-aviso-gratuito--hidden {
    transform: translateX(-50%) translateY(-100%);
  }
  
  .core-aviso-gratuito--hidden:hover {
    transform: translateX(-50%) translateY(0);
  }
  
  .aviso-content {
    padding: 8px 15px;
    gap: 8px;
  }
  
  .aviso-content h4 {
    font-size: 12px;
    white-space: normal; /* Permite quebra de linha em mobile */
    text-align: center;
  }
}

@media (max-width: 480px) {
  #core-aviso-gratuito {
    min-width: 280px;
    width: 90%; /* Usa 90% da largura da tela */
    max-width: 300px;
  }
  
  .aviso-content {
    flex-direction: column;
    gap: 6px;
    padding: 10px;
  }
  
  .aviso-content h4 {
    order: 2;
    font-size: 11px;
    line-height: 1.3;
  }
  
  .toggle-icon {
    order: 1;
  }
  
  .close-btn {
    order: 3;
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
</style>